// Temporary fix to allow multiple instances of bootstrap components
import $ from 'jquery';
import Data from '../../bootstrap/dom/data.js';

const elementMap = new Map();

Data.get = function get(element, key) {
	if (elementMap.has(element)) {
		return elementMap.get(element).get(key) || null;
	}
	return null;
};

Data.set = function set(element, key, instance) {
	if (!elementMap.has(element)) {
		elementMap.set(element, new Map());

		// Cleanup the elementMap when the element is destroyed
		$(element).on('destroy', () => {

			// Destroy all instances for the element
			const instances = elementMap.get(element);

			// Instances might have been disposed already (inside modal.dispose() for example)
			if (instances?.size > 0) {
				for (const [, instance] of instances) {
					try {
						instance.dispose();
					}
					catch (error) {
						console.error('Error while disposing bootstrap component:', error);
					}
				}
			}

			elementMap.delete(element);
		});
	}
	const instanceMap = elementMap.get(element);
	instanceMap.set(key, instance);
};

Data.remove = function remove(element, key) {
	try {
		const instanceMap = elementMap.get(element);
		instanceMap.delete(key);

		// free up element references if there are no instances left for an element
		if (instanceMap.size === 0) {
			elementMap.delete(element);
		}
	}
	catch (error) {
		console.error('Error while removing instance from elementMap:', error);
	}
};

export default Data;